import React from 'react';
import classNames from 'classnames';
import './OutlinedButton.styl';

interface OutlinedButtonProps {
  label: string;
  onClick: React.MouseEventHandler;
  className?: string; // could be any type that classnames supports, but we only use string.
}

// TODO use the mui outlined button variant here instead of custom junk.
/**
 * A transparent button with a border. Becomes slightly translucent on hover.
 */
export const OutlinedButton: React.FC<OutlinedButtonProps> = ({label, onClick, className}) => {
  return (
    <div className={classNames('outlined-button', className)} onClick={onClick}>
      <div className="outlined-button-label">{label}</div>
    </div>
  );
};
